import type { CollectableItem } from "../collectableItem";
import { type TintConfig, type Tintable } from "../interfaces";
import { deserializeItem, deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LootBox } from "./lootBox";
import { BaseKeyCard } from "../items/baseKeyCard";

export class BaseKeyCardLootBox extends LootBox implements Tintable {
	static key = "BaseKeyCardLootBox";

	constructor(xy: XY, loot: CollectableItem[] = [new BaseKeyCard(1)]) {
		super(xy, loot);
	}

	getTint(): TintConfig | null {
		return { r: 255, g: 255, b: 255, minAlpha: 0.0, maxAlpha: 0.3 };
	}

	getAnimationSpeedMultiplier(): number {
		return 1.0;
	}

	static deserialize(data: any): BaseKeyCardLootBox {
		const box = new BaseKeyCardLootBox(deserializeXY(data.xy));
		box.visualId = data.visualId;
		if (data.loot) {
			box.loot = data.loot.map((d: any) => deserializeItem(d));
		}
		return box;
	}
}
